import { render, staticRenderFns } from "./customer.vue?vue&type=template&id=72d407df&"
import script from "./customer.vue?vue&type=script&lang=js&"
export * from "./customer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72d407df')) {
      api.createRecord('72d407df', component.options)
    } else {
      api.reload('72d407df', component.options)
    }
    module.hot.accept("./customer.vue?vue&type=template&id=72d407df&", function () {
      api.rerender('72d407df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/platforms_portal/orders/tabs/customer.vue"
export default component.exports